// extracted by mini-css-extract-plugin
export default {"upload":"Upload_upload__nQE3D","input":"Upload_input__5UPxS","wide":"Upload_wide__oQx66","error":"Upload_error__qvFbw"};